import RestaurantAndCafe from './RestaurantAndCafe'

export default RestaurantAndCafe



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/components/RestaurantAndCafe/index.js